export default __webpack_public_path__ + "static/media/header_logo_2.0ebb8bb3.png";